// v4 — Daily Velocity
import React from 'react';
import { v4data, GOALS, seriesRange } from './v4data';
import { Bars, Ring } from './viz';
import { PageHeader, Card, StatCard, fmt$, fmt$2, fmtN, fmtX } from './v4ui';
import MarkPopup from './MarkPopup';
import './dashboard.scss';

export default function DailyVelocityV4() {
  const D = v4data(30);
  const t = D.ds.accountDaily[D.to];
  const [yy, mm, dd] = D.to.split('-');
  const monthStart = `${yy}-${mm}-01`;
  const daysInMonth = new Date(parseInt(yy), parseInt(mm), 0).getDate();
  const ordersGoal = Math.round((GOALS.revenue / GOALS.aov) / daysInMonth);
  const ordersSeries = seriesRange(D.ds.accountDaily, monthStart, D.to).map((d) => d.totals.orders);
  const pace = (t.orders / ordersGoal) * 100;
  const dateLabel = new Date(parseInt(yy), parseInt(mm) - 1, parseInt(dd)).toLocaleString('en', { month: 'long', day: 'numeric', year: 'numeric' });

  const kpis = [
    { label: 'Orders', value: fmtN(t.orders), valueColor: '#5A54F3' },
    { label: 'Store Revenue', value: fmt$(t.revenue), valueColor: '#8AE8BD' },
    { label: 'Ad Spend', value: fmt$(t.adspend) },
    { label: 'MER', value: fmtX(t.roas), valueColor: '#7A75F6' },
    { label: 'Cost / Order', value: fmt$2(t.cpp) },
    { label: 'Avg Order Value', value: fmt$2(t.aov), valueColor: '#38bdf8' },
  ];

  return (
    <div className="v4-dash">
      <PageHeader title="Daily Velocity" sub={`Your performance for ${dateLabel}`} live />

      <section className="v4-kpis">{kpis.map((k, i) => <StatCard key={i} {...k} />)}</section>

      <section className="v4-secrow">
        <Card className="v4-dv-bars-card" title="Orders This Month" sub="Daily vs goal line">
          <Bars data={ordersSeries} goal={ordersGoal} h={230} colorFor={(v) => (v >= ordersGoal ? '#8AE8BD' : '#5A54F3')} />
          <div className="v4-goal-note">Daily goal = <b>{fmtN(ordersGoal)}</b> orders</div>
        </Card>
        <div className="v4-side">
          <Card className="v4-goalcomplete" title="Goal Completion" sub="Today vs daily target">
            <div className="v4-ring-wrap" style={{ justifyContent: 'center' }}>
              <Ring pct={pace} size={304} thickness={22} label={pace.toFixed(0) + '%'} sub="OF DAILY GOAL" />
            </div>
            <div className="v4-ring-stats" style={{ marginTop: 8 }}>
              <div><span className="l">Today</span><span className="v pos">{fmtN(t.orders)} orders</span></div>
              <div><span className="l">Goal</span><span className="v">{fmtN(ordersGoal)} orders</span></div>
            </div>
          </Card>
        </div>
      </section>

      <MarkPopup />
    </div>
  );
}
